import { useRef as u, useCallback as v, useState as O, useEffect as m, useMemo as _ } from "react";
import { useControlledState as g } from "../../../ariakit-react-utils/esm/hooks.js";
import { usePopoverState as C } from "../popover/popover-state.js";
import { c as R } from "../__utils-b06e21f1.js";
const o = R();
function j(c) {
  let {
    placement: d = "top",
    timeout: n = 0,
    gutter: w = 8,
    ...e
  } = c === void 0 ? {} : c;
  const i = u(), a = u(), l = u(), r = v(() => {
    window.clearTimeout(a.current), window.clearTimeout(l.current);
  }, []), [h, T] = O(e.defaultOpen ?? !1), f = (t) => {
    var p;
    (p = e.setOpen) == null || p.call(e, t), e.open === void 0 && T(t);
  }, [S, b] = g(e.defaultOpen ?? !1, e.open ?? h, (t) => {
    if (r(), t)
      if (!n || o.activeRef)
        o.show(i);
      else {
        o.show(null), a.current = window.setTimeout(() => {
          o.show(i), f(t);
        }, n);
        return;
      }
    else
      l.current = window.setTimeout(() => {
        o.hide(i);
      }, n);
    f(t);
  }), s = C({
    placement: d,
    gutter: w,
    ...e,
    open: S,
    setOpen: b
  });
  return m(() => o.subscribe((t) => {
    t !== i && (r(), s.open && s.hide());
  }), [r, s.open, s.hide]), m(() => () => {
    r(), o.hide(i);
  }, [r]), _(() => ({
    ...s,
    timeout: n
  }), [s, n]);
}
export {
  j as useTooltipState
};
//# sourceMappingURL=tooltip-state.js.map
